import { NgModule } from '@angular/core';
import { HttpClientModule, HttpClient, HTTP_INTERCEPTORS } from '@angular/common/http';
import { RequestInterceptorService } from './providers/interceptors/request.service';

import {
  APP_BASE_HREF,
  LocationStrategy,
  HashLocationStrategy
} from '@angular/common';

// App harness components
import { AppComponent } from './app.component';

import { AppRoutingModule } from './app-routing.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { LoggedInGuard } from './logged-in.guard';
import { ProfileFrameboardModule } from './Components/profile-frameboard/profile-frameboard.module';
import { FooterComponent } from './Components/footer/footer.component';
import { NgIdleKeepaliveModule } from '@ng-idle/keepalive';
import { ArchivosNivel5AutocompleteComponent } from './Components/archivos-nivel5-autocomplete/archivos-nivel5-autocomplete.component';
import {FormsModule} from "@angular/forms";
import {MatAutocompleteModule} from "@angular/material/autocomplete";
import {MatOptionModule} from "@angular/material/core";


@NgModule({
  declarations: [
    AppComponent,
    FooterComponent
  ],
    imports: [
        BrowserAnimationsModule,
        AppRoutingModule,
        HttpClientModule,
        ProfileFrameboardModule,
        NgIdleKeepaliveModule.forRoot(),
        FormsModule,
        MatAutocompleteModule,
        MatOptionModule
    ],

  providers: [
    { provide: APP_BASE_HREF, useValue: '/' },
    { provide: LocationStrategy, useClass: HashLocationStrategy },
    LoggedInGuard,
    HttpClient,
    { provide: HTTP_INTERCEPTORS, useClass: RequestInterceptorService, multi: true },
  ],

  bootstrap: [AppComponent]
})
export class AppModule { }
